const parseHex = (color?: string): [number, number, number] | null => {
  if (!color) return null;

  const hex = color.trim().replace(/^#/, "");

  const full =
    hex.length === 3
      ? hex
          .split("")
          .map((c) => c + c)
          .join("")
      : hex;

  if (!/^[0-9a-f]{6}$/i.test(full)) return null;

  return [
    parseInt(full.slice(0, 2), 16),
    parseInt(full.slice(2, 4), 16),
    parseInt(full.slice(4, 6), 16),
  ];
};

/** Luminância relativa (WCAG), de 0 (preto) a 1 (branco). */
export const getRelativeLuminance = (color?: string): number | null => {
  const rgb = parseHex(color);
  if (!rgb) return null;

  const [r, g, b] = rgb.map((channel) => {
    const sRGB = channel / 255;
    return sRGB <= 0.03928 ? sRGB / 12.92 : ((sRGB + 0.055) / 1.055) ** 2.4;
  });

  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

export const getReadableTextColor = (
  backgroundColor?: string,
  { threshold = 0.5 }: { threshold?: number } = {},
): string => {
  const luminance = getRelativeLuminance(backgroundColor);
  if (luminance === null) return "#ffffff";

  return luminance > threshold ? "#111111" : "#ffffff";
};

/** `true` quando o fundo pede fonte escura. */
export const isLightBackground = (
  backgroundColor?: string,
  options?: { threshold?: number },
): boolean => getReadableTextColor(backgroundColor, options) !== "#ffffff";
